<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.$store.dispatch("lookups/getDoctors");

    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.reasons.totalItems / this.filters.pageSize
      );
    },
    reasons() {
      return this.$store.state.reasons.reasons;
    },
    doctors() {

      return [
        ...this.$store.state.lookups.doctors];
    },

  },

  data() {
    return {
      permissions: this.$settingPermissions.ReviewReasonsPermissions,

      view: 0,
      
      dialog: false,
      dialogType: null,
      dialogMessage: "",
      formDialog: false,

      reason: {
        name: null,
        doctorId: null
      },
      filters: {
        page: 1,
        pageSize: 10,
        doctorId: null,
      },

      headers: [
        { text: 'وصف السبب', value: 'name' },
        { text: ' الطبيب ', value: 'fullName' },
        { text: 'منشأ بواسطة  ', value: 'createdBy' },
        { text: 'تاريخ الانشاء  ', value: 'createdOn' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("reasons/getAll", this.filters);
    },

    addItem() {
      this.view = 1;
      this.formDialog = true;
    },

    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      this.formDialog = true;
      // Implement view logic
    },

    editItem(item) {
      this.itemId = item.id;
      this.reason.name = item.name; //
      this.reason.doctorId = item.doctorId; //
      this.view = 2;
      this.formDialog = true;
      // Implement edit logic
    },
    deleteItem(item) {
      this.itemId = item.id;
      this.$store.dispatch(`reasons/delete`, this.itemId);
    },
    back() {
      this.view = 0;
    },
    // --------------------------form dilog ------------------------------- //

    confirmFormDialog() {
      if (this.reason.name == null || this.reason.name == "" || this.reason.doctorId == null) {
        return false;
      }
      if (this.view == 1) {

        this.$store
          .dispatch("reasons/add", this.reason)
          .then(() => {
            this.cancelFormDialog()
          })
          .catch(() => { });
      }
      else if (this.view == 2) {
        this.$store
          .dispatch("reasons/update", {
            id: this.itemId,
            payload: this.reason
          })
          .then(() => {
            this.cancelFormDialog()
          })
          .catch(() => { });
      }

    },
    cancelFormDialog() {
      this.formDialog = false;
      this.reason= {
        name: null,
        doctorId: null
      };
      this.$refs.reason.reset(); // إعادة تعيين الحقول والتحقق

    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        // case "lock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
        //     break;
        // case "unlock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
        //     break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`reasons/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },

  },
};
</script>

<style scoped></style>